import SchemaLogin from './SchemaLogin'
import SchemaCustomer from './SchemaCustomer'

const SCHEMAS = {
  LOGIN: SchemaLogin,
  CUSTOMER: SchemaCustomer
}

export default SCHEMAS